import "core-js/modules/es.object.freeze";

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import classnames from 'classnames';
import styles from './LoadingSpinner.scss';
var SIZE = Object.freeze({
  small: 'small',
  medium: 'medium',
  large: 'large',
  extraLarge: 'extra-large',
  inherit: 'inherit'
});

var LoadingSpinner = function LoadingSpinner(_ref) {
  var className = _ref.className,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? SIZE.medium : _ref$size;
  return /*#__PURE__*/React.createElement("div", {
    className: classnames(styles.loadingSpinner, className, _defineProperty({}, styles["size-".concat(size)], size !== undefined))
  });
};

LoadingSpinner.SIZE = SIZE;
export default LoadingSpinner;